// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import {
  Review,
  REVIEW_RESULTS
} from '../models';

/**
 * `ReviewResultComponent` implements a view to show the result of a review.
 */
@Component({
  selector: 'she-review-result',
  template: `<span class="she-status she-status-{{review?.result}}">{{getResult()}}</span>`
})
export class ReviewResultComponent {
  /**
   * Current review.
   */
  @Input() review: Review;

  /**
   * Creates a new `ReviewResultComponent` instance.
   */
  constructor() {}

  /**
   * Returns the result of current review.
   * @return Review result
   */
  public getResult(): string {
    return this.review ? REVIEW_RESULTS[this.review.result] : '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/review-result.component.ts